import { render, staticRenderFns } from "./PaidInfoInput.vue?vue&type=template&id=148e54e2&scoped=true"
import script from "./PaidInfoInput.vue?vue&type=script&lang=js"
export * from "./PaidInfoInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e54e2",
  null
  
)

export default component.exports